import { useState } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const useAdvisorForm = (onSuccess, onClose) => {
  const [formData, setFormData] = useState({ name: '', email: '', company: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const authToken = localStorage.getItem('auth_token');
      const response = await fetch(`${API_URL}/api/admin/advisors`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(authToken ? { 'Authorization': `Bearer ${authToken}` } : {}),
        },
        body: JSON.stringify(formData),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.detail || 'Failed to create trusted professional');
      setFormData({ name: '', email: '', company: '' });
      onSuccess(data);
      onClose();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return { formData, loading, error, handleSubmit, handleChange };
};
